import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmark: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBookmark"><Path d="M4 2V22.5204L12 18.1066L20 22.5204V2H4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookmark;
